import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Drawer, Button } from 'antd';
import { FaFilter } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { Filters } from '@/layout/common-filter/Filters';
import { DrawerGlobalStyles } from '@/layout/common-filter/styles/Filters.styles';
import { addReleases } from '@/pages/releases/release-list/releaseListSlice';
import { addAlerts } from '@/pages/alerts/alertSlice';
import { addResources } from '@/pages/resources/resourceCardsSlice';
import {
  clearFiltersOnPageChange,
  resetFilters,
  updatePageNumber,
  updateResourcePageNumber,
} from '@/layout/common-filter/filtersSlice';

/**
 * DrawerFilter - Floating filter button that opens filter drawer
 * @param {Object} props - Component props
 * @param {string} props.currentPageName - Current page identifier for filters
 * @return {JSX.Element} Drawer filter component
 */
export const DrawerFilter = ({ currentPageName }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const previousPageNameRef = useRef(null);

  // Reset filters when page changes
  useEffect(() => {
    if (
      previousPageNameRef.current &&
      previousPageNameRef.current !== currentPageName
    ) {
      dispatch(addReleases([]));
      dispatch(addAlerts([]));
      dispatch(addResources([]));
      dispatch(updatePageNumber(0));
      dispatch(updateResourcePageNumber(0));
      dispatch(clearFiltersOnPageChange());
      dispatch(
        resetFilters({
          page: 0,
          resourceNameString: '',
          application: [],
          resourceName: [],
          namespace: [],
          resourceGroup: [],
          allResources: 0,
        }),
      );
    }
    previousPageNameRef.current = currentPageName;
  }, [currentPageName, dispatch]);

  /**
   * Show the filter drawer
   */
  const showDrawer = () => {
    setOpen(true);
  };

  /**
   * Close the filter drawer
   */
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <DrawerGlobalStyles />
      <div
        id="sosCommonFilterSection"
        style={{ position: 'fixed', top: '56px', right: '10px', zIndex: '10' }}
      >
        <Button
          icon={<FaFilter />}
          onClick={showDrawer}
          aria-label="Open filters"
        />

        <Drawer
          placement="right"
          closable={false}
          onClose={onClose}
          open={open}
          width={340}
          zIndex={1000}
        >
          <Filters page={currentPageName} hideFilter={onClose} />
        </Drawer>
      </div>
    </>
  );
};

DrawerFilter.propTypes = {
  currentPageName: PropTypes.string.isRequired,
};
